var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ lightbox: true, visible: _vm.visible }},[_c('div',{staticClass:"lightbox-body",domProps:{"innerHTML":_vm._s(_vm.body)}}),_vm._v(" "),_c('i',{staticClass:"sgi sgi-times",on:{"click":_vm.close}})])}
var staticRenderFns = []

export { render, staticRenderFns }